var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.8333 179.667C139.446 179.667 179.667 139.447 179.667 89.8333C179.667 40.2197 139.446 0 89.8333 0C40.2197 0 0 40.2197 0 89.8333C0 139.447 40.2197 179.667 89.8333 179.667Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8335 44.2871C71.238 44.2871 56.146 59.3791 56.146 77.9743C56.146 96.2104 70.4295 111.033 89.3843 111.572C89.6538 111.572 90.0132 111.572 90.1928 111.572C90.3725 111.572 90.642 111.572 90.8217 111.572C90.9115 111.572 91.0013 111.572 91.0013 111.572C109.148 110.943 123.431 96.2104 123.521 77.9743C123.521 59.3791 108.429 44.2871 89.8335 44.2871Z",
    fill: "#D6D6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.747 155.861C134.756 170.594 113.376 179.667 89.8396 179.667C66.3033 179.667 44.923 170.594 28.9326 155.861C31.0886 147.687 36.9278 140.23 45.462 134.481C69.9865 118.131 109.872 118.131 134.217 134.481C142.841 140.23 148.591 147.687 150.747 155.861Z",
    fill: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0b6a542cba666ae055cbd17ceeafaa87.svg";
export { ForwardRef as ReactComponent };